var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultCardLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 26,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.25.625C1.01.625 0 1.635 0 2.875v2.25h36v-2.25c0-1.24-1.008-2.25-2.25-2.25H2.25ZM0 11.875v11.25c0 1.242 1.01 2.25 2.25 2.25h31.5a2.251 2.251 0 0 0 2.25-2.25v-11.25H0Zm5.625 4.5h4.5a1.125 1.125 0 1 1 0 2.25h-4.5a1.125 1.125 0 1 1 0-2.25Z"
})));
SvgDefaultCardLogo.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultCardLogo);
export default ForwardRef;